import { fieldName } from './defaultAddress';

const reLetters = /^[a-zA-Z\u00C0-\u00FF\-.,()'‘’·/\s]+$/;
const reLettersAndNumbers = /^[0-9a-zA-Z\u00C0-\u00FF\-.,()'‘’·/\s]+$/;

export const validate = (name, value) => {
    let error;

    if (value) {
        if (name === fieldName.ZIPCODE || name === fieldName.HOUSENUMBER) {
            if (!reLettersAndNumbers.test(value)) {
                error = 'NEW_CHECKOUT_SHIPPING_ERROR_MATCH';
            }
        } else if (
            name === fieldName.STREET ||
            name === fieldName.CITY ||
            name === fieldName.COUNTRY_NAME
        ) {
            if (!reLetters.test(value)) {
                error = 'NEW_CHECKOUT_SHIPPING_ERROR_MATCH';
            }
        }
    }

    return error;
};
